"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("./constants");
exports.default = {
    root: {
        overflow: 'auto',
        padding: constants_1.MODAL_PADDING,
        '&[data-is-centered=true]': {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'flex-start'
        }
    },
    content: {
        flexGrow: 1
    }
};
//# sourceMappingURL=modal.content.style.js.map